import styled from 'styled-components';

import { Divider, Text, useTheme, utils } from '@desygner/ui-common-components';
import { useTranslation } from '@desygner/ui-common-translation';

import { ExternalShareGroup, ExternalShareType } from '../ShareAccess.types';
import { SingleExternalShare } from './SingleExternalShare';

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

const StyledGroupTitle = styled.div`
  width: 100%;
  display: flex;
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.MediumSmall)};
  align-items: center;
`;

const StyledTitle = styled.div`
  flex: none;
`;

const StyledGroupWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
  gap: ${({ theme }) => utils.rem(theme.Spacing.Size.XSmall)};
`;

export type GroupExternalShareProps = {
  group: ExternalShareGroup;
  onItemClick: (id: ExternalShareType['id']) => void;
};

export function GroupExternalShare({ group, onItemClick }: GroupExternalShareProps) {
  const theme = useTheme();
  const { t } = useTranslation();

  return (
    <StyledWrapper>
      <StyledGroupTitle>
        <StyledTitle>
          <Text size={'Body'} color={theme.Color.Neutrals.Dark}>
            {t(group.titleKey)}
          </Text>
        </StyledTitle>
        <Divider />
      </StyledGroupTitle>
      <StyledGroupWrapper>
        {group.shares.map((share) => (
          <SingleExternalShare
            key={`share-${share.id}`}
            share={share}
            onClick={() => {
              onItemClick(share.id);
            }}
          />
        ))}
      </StyledGroupWrapper>
    </StyledWrapper>
  );
}
